import { FreeCamera } from '@babylonjs/core/Cameras/freeCamera';
export const checkFreeCamera = (value) => {
    if (!(value instanceof FreeCamera)) {
        throw new Error(`Expected FreeCamera, but received ${String(value)}`);
    }
    return value;
};
